module.exports = __webpack_public_path__ + "VodafoneLt_W.e3bb46c00eca19c30e55.woff";


//////////////////
// WEBPACK FOOTER
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/assets/fonts/VodafoneLt_W.woff
// module id = ../../../../../src/assets/fonts/VodafoneLt_W.woff
// module chunks = styles